import { Portal } from '@/components/portal'
import ZendeskForm from '@/components/zendesk-form'

import {
  BlackFridayBlog,
  BlackFridayComparison,
  BlackFridayLogos,
  BlackFridayOtherFeatures,
  BlackFridayStats,
  EnterprisePromotionCta,
  EnterprisePromotionFeatures,
  EnterprisePromotionHero
} from '../../../devlink'

const HalifaxLandords = () => {
  return (
    <>
      <Portal targetId="zendesk-form">
        <ZendeskForm
          zendeskSubject="Holiday enterprise promotion"
          zendeskClickId="bf_30offenterprise_claimdiscount_click"
          zendeskSubmitEvent="bf_30offenterprise_claimdiscount_click"
          bookADemoClickId="bf_30offenterprise_claimdiscount_bookdemo"
        />
      </Portal>
      <div className="webflow-page">
        <EnterprisePromotionHero />
        <BlackFridayLogos />
        <EnterprisePromotionFeatures />
        <BlackFridayOtherFeatures />
        <BlackFridayComparison />
        <BlackFridayStats />
        <EnterprisePromotionCta />
        <BlackFridayBlog />
      </div>
    </>
  )
}

export default HalifaxLandords
